var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5025 11H3C2.175 11 1.5 11.675 1.5 12.5V17H6.5025V11Z",
    stroke: "#1B2436",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9975 8H7.995C7.17 8 6.495 8.675 6.495 9.5V17H11.4975V9.5C11.4975 8.675 10.83 8 9.9975 8Z",
    stroke: "#1B2436",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.25H11.4975V17H16.5V14.75C16.5 13.925 15.825 13.25 15 13.25Z",
    stroke: "#1B2436",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39 2.05408L9.7875 2.84907C9.84 2.96157 9.98251 3.06657 10.1025 3.08157L10.8225 3.20158C11.28 3.27658 11.3925 3.61406 11.0625 3.93656L10.5 4.49906C10.4025 4.59656 10.35 4.77657 10.38 4.90407L10.5375 5.59408C10.665 6.14158 10.3725 6.35158 9.8925 6.06658L9.21751 5.66908C9.09751 5.59408 8.89501 5.59408 8.77501 5.66908L8.1 6.06658C7.62 6.35158 7.3275 6.14158 7.455 5.59408L7.61251 4.90407C7.64251 4.77657 7.59001 4.58906 7.49251 4.49906L6.9375 3.94407C6.6075 3.61407 6.7125 3.28406 7.1775 3.20906L7.8975 3.08908C8.0175 3.06658 8.16001 2.96158 8.21251 2.85658L8.61 2.06156C8.8275 1.62656 9.1725 1.62658 9.39 2.05408Z",
    stroke: "#1B2436",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingScale);
export default __webpack_public_path__ + "static/media/RatingScale.c1a60dbed898b65d3ba5e74ea07616e2.svg";
export { ForwardRef as ReactComponent };